import Layout from "./layout/Layout";

function App() {
  return (
    <div>
      <Layout/>
    </div>
  );
}

export default App;
